__turbopack_context__.v({
  "AuthorCardContent": "AuthorCard-module__wrbMEa__AuthorCardContent",
  "author-booklist-header": "AuthorCard-module__wrbMEa__author-booklist-header",
  "author-books": "AuthorCard-module__wrbMEa__author-books",
  "author-details": "AuthorCard-module__wrbMEa__author-details",
  "author-name": "AuthorCard-module__wrbMEa__author-name",
});
